const GetIconHeader = (headerName, icon) => {
    return `
    <div>
        <span style="display:flex;justify-content:center;">
            <img style="height: 20px; margin-bottom: 10px;" src=${icon} alt=${headerName} />
        </span>
        <div ref="eLabel" class="ag-header-cell-label text-xs">${headerName}
            <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
            <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>
            <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>
        </div>
    </div>`;
};

export default GetIconHeader;
